module.exports = __webpack_public_path__ + "img/gl.c02d7370.svg";